import { useFormContext, useFormField } from '@calendly/form'
import { useCallback, useRef } from 'react'

export const useFieldStatus = (props) => {
  const [{ name }] = useFormField(props)
  const { status, setStatus } = useFormContext()
  const statusRef = useRef(status || {})

  const setFieldStatus = useCallback((fieldStatus) => {
    statusRef.current = {
      ...statusRef.current,
      [name]: fieldStatus
    }
    setStatus(statusRef.current)
  }, [name, setStatus])

  return [
    status && status[name],
    setFieldStatus
  ]
}
